import { RemoteData } from 'app/infrastructure/remote-data/index';
import { endpoint as favouriteEndpoint } from 'app/area/favourite/constants';

export const api = {

  createSearchForCasesToConnect: async (caseDraftId: number, connectionTypeId: number): Promise<number> => {
    const result = await new RemoteData(`${favouriteEndpoint.connectedCasesFavouriteDefinition}`)
      .resource<any>()
      .filter({
        caseDraftId,
        connectionTypeId
      })
      .create(undefined);
    const obj = await result.json();
    return obj.data;
  }

};
